import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import '../styles/graph.scss';
import api from '../api'; // Ajuste o caminho da importação do seu arquivo api
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

// Registre os componentes que você usará
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const RelatoriosGraficos = () => {
    const [relatorioCursos, setRelatorioCursos] = useState([]);
    const [relatorioMaisOfertados, setRelatorioMaisOfertados] = useState([]);
    const [relatorioStatusCursos, setRelatorioStatusCursos] = useState([]);
    const [ingressos, setIngressos] = useState([]);
    const [mes, setMes] = useState(1);  // Estado para armazenar o mês selecionado
    const [ano, setAno] = useState(2024);  // Estado para armazenar o ano selecionado

    // Definindo número de itens por página (aplicado aos gráficos)
    const cursosPorPagina = 1; // Um gráfico por página

    // Estado da página atual
    const [currentPage, setCurrentPage] = useState(1);

    // Função de paginação
    const getPaginationButtons = (totalPages, currentPage, setCurrentPage) => {
        const buttons = [];

        buttons.push(1);

        if (currentPage > 3) {
            buttons.push("...");
        }

        for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
            buttons.push(i);
        }

        if (currentPage < totalPages - 2) {
            buttons.push("...");
        }

        if (totalPages > 1) {
            buttons.push(totalPages);
        }

        return (
            <div className="pagination">
                {buttons.map((page, index) => (
                    <button
                        key={index}
                        onClick={() => {
                            if (page !== "...") {
                                setCurrentPage(page);
                            }
                        }}
                        disabled={page === "..."}>
                        {page}
                    </button>
                ))}
            </div>
        );
    };

    // Função para obter os gráficos
    const getCurrentGraphData = () => {
        switch (currentPage) {
            case 1:
                return dadosIngressos;
            case 2:
                return dadosCursosMaisOfertados;
            case 3:
                return dadosStatusCursos;
            default:
                return dadosIngressos;
        }
    };

    // Dropdowns de mês e ano
    const meses = [
        { value: 1, label: 'Janeiro' },
        { value: 2, label: 'Fevereiro' },
        { value: 3, label: 'Março' },
        { value: 4, label: 'Abril' },
        { value: 5, label: 'Maio' },
        { value: 6, label: 'Junho' },
        { value: 7, label: 'Julho' },
        { value: 8, label: 'Agosto' },
        { value: 9, label: 'Setembro' },
        { value: 10, label: 'Outubro' },
        { value: 11, label: 'Novembro' },
        { value: 12, label: 'Dezembro' }
    ];

    const anos = [2024, 2025, 2026]; // Exemplo de anos disponíveis

    // Funções para buscar os dados
    const fetchRelatorioCursos = async () => {
        try {
            const response = await api.get('/relatorio/cursos');
            const cursos = Object.entries(response.data.cursoPorPolo).flatMap(([curso, polos]) =>
                polos.map(polo => ({
                    'CURSO OFERTADO': curso,
                    'QUANTIDADE': polos.length,
                    'POLO': polo.nome
                }))
            );
            setRelatorioCursos(cursos);
        } catch (error) {
            console.error('Erro ao buscar relatório de cursos:', error);
        }
    };

    const fetchRelatorioMaisOfertados = async () => {
        try {
            const response = await api.get('/relatorio/cursos');
            const cursosMaisOfertados = response.data.cursosMaisOfertados.map(([curso, quantidade]) => ({
                'CURSO OFERTADO': curso,
                'QUANTIDADE': quantidade,
            }));
            setRelatorioMaisOfertados(cursosMaisOfertados);
        } catch (error) {
            console.error('Erro ao buscar relatório de cursos mais ofertados:', error);
        }
    };

    const fetchRelatorioStatusCursos = async () => {
        try {
            const response = await api.get('/relatorio/cursos');
            const statusCursos = Object.entries(response.data.statusCursos).map(([curso, status]) => ({
                'CURSO OFERTADO': curso,
                'ATIVAS': status.ativas,
                'INATIVAS': status.inativas,
            }));
            setRelatorioStatusCursos(statusCursos);
        } catch (error) {
            console.error('Erro ao buscar relatório de status de cursos:', error);
        }
    };

    const fetchIngressos = async (month, year) => {
        try {
            const response = await api.get(`/relatorio/ingressos/${month}/${year}`);
            setIngressos(response.data.ingressos);
        } catch (error) {
            console.error('Erro ao buscar relatório de ingressos:', error);
        }
    };

    // useEffect para buscar os dados ao carregar a página
    useEffect(() => {
        fetchRelatorioCursos();
        fetchRelatorioMaisOfertados();
        fetchRelatorioStatusCursos();
    }, []); // Carrega os dados de cursos e status uma vez quando o componente for montado

    // useEffect para buscar os ingressos quando os valores de mês ou ano mudarem
    useEffect(() => {
        fetchIngressos(mes, ano); // Atualiza os ingressos com base nos valores de mês e ano
    }, [mes, ano]); // Re-executa sempre que os valores de mes ou ano mudam

    // Dados dos gráficos
    const dadosIngressos = {
        labels: Object.keys(ingressos),
        datasets: [
            {
                label: 'Ingressos por Polo',
                data: Object.values(ingressos),
                backgroundColor: 'rgba(233, 78, 27, 0.6)',
            },
        ],
    };

    const dadosCursosMaisOfertados = {
        labels: relatorioMaisOfertados.map(item => item['CURSO OFERTADO']),
        datasets: [
            {
                label: 'Cursos Mais Ofertados',
                data: relatorioMaisOfertados.map(item => item['QUANTIDADE']),
                backgroundColor: 'rgba(243, 146, 0, 0.6)',
            },
        ],
    };

    const dadosStatusCursos = {
        labels: relatorioStatusCursos.map(item => item['CURSO OFERTADO']),
        datasets: [
            {
                label: 'Ativas',
                data: relatorioStatusCursos.map(item => item['ATIVAS']),
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
            },
            {
                label: 'Inativas',
                data: relatorioStatusCursos.map(item => item['INATIVAS']),
                backgroundColor: 'rgba(168, 168, 168, 0.6)',
            },
        ],
    };

    // Total de páginas é 3, pois temos 3 gráficos
    const totalPages = 3;

    return (
        <div>
            {/* Dropdowns para selecionar mês e ano */}
            <div 
                className="filters" 
                style={{ display: currentPage !== 1 ? 'none' : 'block' }} // Condicional de display
            >
                <label htmlFor="mes">Mês:</label>
                <select id="mes" value={mes} onChange={(e) => setMes(Number(e.target.value))}>
                    {meses.map((item) => (
                        <option key={item.value} value={item.value}>
                            {item.label}
                        </option>
                    ))}
                </select>
    
                <label htmlFor="ano">Ano:</label>
                <select id="ano" value={ano} onChange={(e) => setAno(Number(e.target.value))}>
                    {anos.map((item) => (
                        <option key={item} value={item}>
                            {item}
                        </option>
                    ))}
                </select>
            </div>
    
            {/* Renderiza o gráfico atual com base na página */}
            <h1>{currentPage === 1 ? "Ingressos por Polo" : currentPage === 2 ? "Cursos Mais Ofertados" : "Status dos Cursos"}</h1>
            <Bar data={getCurrentGraphData()} />
    
            {/* Paginação */}
            {getPaginationButtons(totalPages, currentPage, setCurrentPage)}
        </div>
    );
    
};

export default RelatoriosGraficos;
